import React from "react";
import { Modal, Form, message, Button, Table } from "antd";

import File from "./File";
import global from '../../../common/utility/global';
class CargaMasivaModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChangeFile = async (event) => {
    var file = event.target.files[0];
    if (!file) return;

    var fileExtension = file.name.split(".")[1];
    var fileSize = Math.floor(file.size / 1024);
    var allowedExtensions = ["xlsx"];

    if (
      allowedExtensions.filter((m) => {
        return m === fileExtension;
      }).length === 0
    ) {
      message.error(
        "Solo puede subir archivos: " + allowedExtensions.join(" / ") + "."
      );
      return;
    }

    if (fileSize > 5120) {
      message.error(
        "Tamaño máximo permitido " +
        parseFloat(parseFloat(fileSize / 1024).toFixed(2)).toString() +
        " mb."
      );
      return;
    }

    this.props.form.setFieldsValue({
      nombreArchivo: file.name,
      icon: "loading",
    });

    var response = await this.props.onUploadFile(file);

    if (response.status !== 200) {
      message.error("Ocurrió un error al intentar subir el archivo.");
      this.handleRemoveFile();
      return;
    }
    this.props.form.setFieldsValue({
      icon: "folder-open",
      url: response.data.url,
      listaCargaMasiva: response.data.listaCargaMasiva
    });
  };

  handleRemoveFile = () => {
    global.cleanInputFile(
      this.props.form.getFieldValue("identifier"),
      this.handleChangeFile
    );
    this.props.form.setFieldsValue({
      url: "",
      nombreArchivo: "",
      listaCargaMasiva: [],
      icon: "folder-open",
    });
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {

        if (values.listaCargaMasiva.length === 0) {
          message.warning('No hay registros para la Carga Masiva.');
          return;
        }

        if (values.listaCargaMasiva.filter(m => m.flagProductoCorrecto === false).length > 0) {
          message.warning('El archivo seleccionado tiene observaciones, seleccione otro archivo.');
          return;
        }

        const form = {
          listaCargaMasiva: values.listaCargaMasiva
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    getFieldDecorator("identifier", { initialValue: "file-carga-masiva" });
    getFieldDecorator("url", { initialValue: this.props.formValues.url });
    getFieldDecorator("nombreArchivo", {
      initialValue: this.props.formValues.nombreArchivo,
    });
    getFieldDecorator("listaCargaMasiva", {
      initialValue: this.props.formValues.listaCargaMasiva
        ? this.props.formValues.listaCargaMasiva
        : [],
    });
    getFieldDecorator("icon", { initialValue: "folder-open" });
    return (
      <Modal
        title={"Carga Masiva de Productos"}
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="1100px"
      >
        <Form>
          <div className="row">
            <div className="col-md-6 form-group">
              <Button
                icon="file-excel"
                type="primary"
                onClick={this.props.onDownloadFormatoCargaMasiva}
              >
                Descargar Formato Carga Masiva
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Seleccionar Formato de Carga">
                <File
                  identifier={getFieldValue("identifier")}
                  filename={getFieldValue("nombreArchivo")}
                  downloadUrl={getFieldValue("url")}
                  icon={getFieldValue("icon")}
                  onChange={this.handleChangeFile}
                  onRemove={this.handleRemoveFile}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <Table
              className={"table-producto"}
              scroll={{ x: true }}
              size="default"
              style={{ overflowX: 'auto' }}
              pagination={false}
              dataSource={getFieldValue("listaCargaMasiva")}
              rowKey={(record) => record.identifier}
              columns={[
                {
                  title: "Nombre",
                  dataIndex: "nombre",
                  key: "nombre",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Código Referencia",
                  dataIndex: "codigoReferencia",
                  key: "codigoReferencia",
                  align: "left",
                  width: 65,
                  ellipsis: true,

                },
                {
                  title: "Código Barra",
                  dataIndex: "codigoBarra",
                  key: "codigoBarra",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Código SUNAT",
                  dataIndex: "codigoSunat",
                  key: "codigoSunat",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Impuesto",
                  dataIndex: "valorImpuesto",
                  key: "valorImpuesto",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Stock Mínimo",
                  dataIndex: "stockMin",
                  key: "stockMin",
                  align: "left",
                  width: 65,
                },
                {
                  title: "Stock Maximo",
                  dataIndex: "stockMax",
                  key: "stockMax",
                  align: "left",
                  width: 65,
                },
                {
                  title: "Peso",
                  dataIndex: "peso",
                  key: "peso",
                  align: "left",
                  width: 65,
                },
                {
                  title: "Flag Gratuito",
                  dataIndex: "valorGratuito",
                  key: "valorGratuito",
                  align: "center",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "ICBPER",
                  dataIndex: "valorICBPER",
                  key: "valorICBPER",
                  align: "center",
                  width: 65,
                  ellipsis: true,
                },

                {
                  title: "Observación",
                  dataIndex: "observacion",
                  key: "observacion",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Código Unidad Medida Sunat",
                  dataIndex: "codigoUnidadMedidaSunat",
                  key: "codigoUnidadMedidaSunat",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Codigo Categoria",
                  dataIndex: "codigoCategoria",
                  key: "codigoCategoria",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Aplica Vencimiento",
                  dataIndex: "aplicaVencimiento",
                  key: "aplicaVencimiento",
                  align: "center",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Aplica Serie",
                  dataIndex: "aplicaSerie",
                  key: "aplicaSerie",
                  align: "center",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Codigo Marca",
                  dataIndex: "codigoMarca",
                  key: "codigoMarca",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
                {
                  title: "Modelo",
                  dataIndex: "modelo",
                  key: "modelo",
                  align: "left",
                  width: 65,
                  ellipsis: true,
                },
              ]}
            />
          </div>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(CargaMasivaModal);
